import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import _ from 'lodash';
import { $definitions } from 'ziphy-web-shared/basic/entities/notes/definitions';
import styles from './BlockReviewOfSystems.module.scss';
import BlockReviewOfSystemsButtons from './BlockReviewOfSystemsButtons';
const BlockReviewOfSystems = ({ $element }) => {
    const { renderType } = $element;
    const ros = $element.builder.variables.top_select_id;
    const selects = useMemo(() => Object.entries($definitions.selects.valuesMap(ros)), [ros]);
    if (renderType === 'plain') {
        const values = $element.builder.form.outputValues();
        const symptoms = _.flatMap(values, (obj, outerKey) => _.keys(_.pickBy(obj, (value) => value === true || (typeof value === 'string' && value.length > 0))).map((innerKey) => {
            if (innerKey === 'other') {
                return values[outerKey][innerKey];
            }
            else {
                return $definitions.selects.valuesMap(`ros_${outerKey}_${innerKey}`).yes.title;
            }
        }));
        return (_jsx("div", Object.assign({ className: styles.plain }, { children: symptoms.length > 0
                ? $element.config.customData.positive.replace('{{symptoms}}', symptoms.join(', '))
                : $element.config.customData.negative })));
    }
    return (_jsx("div", Object.assign({ className: styles.form }, { children: selects.map(([key, item]) => {
            return (_jsxs("div", Object.assign({ className: styles.formBlock }, { children: [_jsx("div", Object.assign({ className: styles.formBlockLeft }, { children: item.title })), _jsx("div", Object.assign({ className: styles.formBlockRight }, { children: _jsx(BlockReviewOfSystemsButtons, { definition: item, "$element": $element }) }))] }), key));
        }) })));
};
export default observer(BlockReviewOfSystems);
